'use client';
import { useEffect, useState } from 'react';
import { client } from '@/sanity/lib/client';
import { ARTICLES_LIST_CONFIG_QUERY } from '@workspace/sanity-base/queries/articlesList';

export type ArticlesListConfig = {
  askGreg?: {
    isEnabled: boolean;
    heading?: string;
    description?: string;
    subheading?: string;
    prompts?: string[];
    isShowButton?: boolean;
    backgroundColor?: string;
  };
  showItemsPerPageSelector?: boolean;
  isIncludedContactSupport?: boolean;
  heroBanner?: {
    isActive: boolean;
  };
  ui: {
    searchIntroText: string;
    searchPlaceholder: string;
    filterSectionLabel: string;
    filters: {
      attribute: { name: string };
      placeholder?: string;
      _key?: string;
      options: string;
    }[];
    showItemsPerPageSelector?: boolean;
  };
};

export const useArticlesListConfig = (type: 'case-studies' | 'blogs' | 'news') => {
  const [config, setConfig] = useState<ArticlesListConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        const data = await client.fetch(ARTICLES_LIST_CONFIG_QUERY, { type });
        setConfig(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch articles list config');
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [type]);

  return { config, loading, error };
};
